import moment from 'moment';
import Card from '../../../components/Card';
import { TradeHistory } from '../../../hooks/web3/trade/useTradeHistory';
import AssetType from '../../../components/AssetType';
import { formatAmountWithSuffix, formatUSD } from '../../../helpers';
import useTradePools from '../../../hooks/web3/trade/useTradePools';
import { parseEther } from 'ethers/lib/utils';

type HistoryRowProps = {
    history: TradeHistory;
    style?: React.CSSProperties;
};

const HistoryRow: React.FC<HistoryRowProps> = ({ history, style }) => {
    const { tradePools } = useTradePools();

    const tradePair = tradePools?.find(
        ({ address }) => address.toLowerCase() === history.tradePair.id.toLowerCase()
    );

    const hasProfit = parseEther(history.pnl).gte(0);

    return (
        <div
            className={`row ${history.type.toLowerCase()} position-id-${
                history.positionId
            }`}
            style={style}
        >
            <Card style={style}>
                <div className='exchange-history__date'>
                    {moment.unix(history.timestamp).format('YYYY-MM-DD HH:mm:ss')}
                </div>
                <div className='exchange-history__mobile-wrapper'>
                    <div className='exchange-history__type'>
                        <span className='column-label'>Type</span>
                        <AssetType
                            tradePair={tradePair}
                            isShort={history.type === 'SHORT'}
                            leverage={history.leverage}
                        />
                    </div>
                    <div className='border' />
                    <div className='exchange-history__size'>
                        <span className='column-label'>Size</span>
                        {formatAmountWithSuffix(history.volume || 0, {
                            minDecimals: 2,
                            currency: 'USD',
                            minValue: 1_000_000_000,
                        })}
                    </div>
                    <div className='exchange-history__entry-price'>
                        <span className='column-label'>Entry Price</span>
                        {formatUSD(history.entryPrice || 0, {
                            minDecimals: 2,
                            maxDecimals: tradePair?.decimalFormatting,
                        })}
                    </div>
                    <div className='exchange-history__close-price'>
                        {formatUSD(history.closePrice || 0, {
                            minDecimals: 2,
                            maxDecimals: tradePair?.decimalFormatting,
                        })}
                    </div>
                    <div className='border' />
                    <div
                        className={`exchange-history__realized-pnl ${
                            hasProfit ? 'increased' : 'decreased'
                        }`}
                    >
                        <span className='column-label'>Realized PNL</span>
                        <div className='pnl-value-wrapper'>
                            <span>
                                {formatAmountWithSuffix(history.pnl || 0, {
                                    minValue: 10_000_000,
                                    minDecimals: 2,
                                    currency: 'USD',
                                })}
                                &nbsp;
                            </span>
                            <span>
                                ({hasProfit ? '+' : ''}
                                {formatAmountWithSuffix(history.pnlPercent, {
                                    minValue: 10_000,
                                    minDecimals: 2,
                                })}
                                %)
                            </span>
                        </div>
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default HistoryRow;
